import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tenant-bid-shipment.reducer';

export const TenantBidShipmentDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tenantBidShipmentEntity = useAppSelector(state => state.tenantBidShipment.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tenantBidShipmentDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tenantBidShipment.detail.title">TenantBidShipment</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tenantBidShipment.id">Id</Translate>
            </span>
          </dt>
          <dd>{tenantBidShipmentEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tenantBidShipment.active">Active</Translate>
            </span>
          </dt>
          <dd>{tenantBidShipmentEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tenantBidShipment.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{tenantBidShipmentEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantBidShipment.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{tenantBidShipmentEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantBidShipment.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{tenantBidShipmentEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantBidShipment.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{tenantBidShipmentEntity.timestampEntry}</dd>
          <dt>
            <span id="shipmentStatus">
              <Translate contentKey="tinyMedicRestApp.tenantBidShipment.shipmentStatus">Shipment Status</Translate>
            </span>
          </dt>
          <dd>{tenantBidShipmentEntity.shipmentStatus}</dd>
          <dt>
            <span id="carrier">
              <Translate contentKey="tinyMedicRestApp.tenantBidShipment.carrier">Carrier</Translate>
            </span>
          </dt>
          <dd>{tenantBidShipmentEntity.carrier}</dd>
          <dt>
            <span id="carrierMobileNo">
              <Translate contentKey="tinyMedicRestApp.tenantBidShipment.carrierMobileNo">Carrier Mobile No</Translate>
            </span>
          </dt>
          <dd>{tenantBidShipmentEntity.carrierMobileNo}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantBidShipment.tenantBid">Tenant Bid</Translate>
          </dt>
          <dd>{tenantBidShipmentEntity.tenantBid ? tenantBidShipmentEntity.tenantBid.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tenant-bid-shipment" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/tenant-bid-shipment/${tenantBidShipmentEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TenantBidShipmentDetail;
